module.exports = __webpack_public_path__ + "img/shouye-zizhi-png-02.d52812a1.svg";